var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"banner"},[_c('el-carousel',{staticClass:"banner_img",attrs:{"trigger":"click"}},_vm._l((_vm.bannerList),function(item,index){return _c('el-carousel-item',{key:index},[_c('a',{attrs:{"href":item.linkurl,"target":"_blank"}},[_c('img',{attrs:{"src":item.linkimg}})])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }